var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"disabled":_vm.budget.budget_status_id == 2,"variant":"primary","id":"btn_actualizar_en_vender"},on:{"click":_vm.update}},[_vm._v(" Actualizar en VENDER ")])
}
var staticRenderFns = []

export { render, staticRenderFns }